// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"resourcesDetails_imageContainer__KK34N","pageDetails":"resourcesDetails_pageDetails__KGhus"};